export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  OPEN_INTERNAL_SUPPORT: 'openInternalSupport',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  WEBSOCKET_RECONNECT_FAILED: 'WEBSOCKET_RECONNECT_FAILED',
  CONVERSATION_DELETED: 'CONVERSATION_DELETED',
  CONTACT_CREATED: 'CONTACT_CREATED',
  CONTACT_MERGED: 'CONTACT_MERGED',
  CURRENT_USER_ACCESS_CHANGED: 'CURRENT_USER_ACCESS_CHANGED',
  INBOX_ACCESS_CHANGED: 'INBOX_ACCESS_CHANGED',
  // Asks the chat list to re-fetch its filtered view or folder after a reconnect.
  CHAT_LIST_RECONNECT_SYNC: 'CHAT_LIST_RECONNECT_SYNC',
  // Asks the chat list to start over from page 1 of its view (filters kept) after a long gap.
  CHAT_LIST_RELOAD: 'CHAT_LIST_RELOAD',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  WORKSPACE_DEMO_OPEN_ONBOARDING_VIDEO: 'workspaceDemoOpenOnboardingVideo',
};
